<div class="flex h-screen w-full flex-col items-center justify-center gap-2 text-center">
    <h1 class="text-2xl font-semibold">{{ 'auth.unauthorized.title' | translate }}</h1>
    <p>{{ 'auth.unauthorized.message' | translate }}</p>
</div>
